<mat-dialog-content> 
    <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>  
      <app-change-password (closeDialog)="isClosed($event)"></app-change-password>
</mat-dialog-content>